import _html_handler from "./_html_handler";
import('../../../../styles/components/map/layer_control.css');
import _filter from "./_filter";
import Toast from "../../toast/toast";
import _http_v1 from "@packs/http_requests/_http_v1";

global.RBush = require('@packs/leaflet/RBush') //dependência camada de markers com canvas
require('@packs/leaflet/leaflet_canvas_markers') ////camada de markers com canvas

/**
 * options{
 *  map: instancia do mapa
 *  container: container onde vai estar o controle de camadas
 *  layers: lista de camadas
 *  exemplo de layer:{
        title: 'Limite Municipal',
        description: 'Limites do estado de São Paulo',
        controls:{
            stroke: {title: 'Traçado',color: true,opacity: true, width:5,dcolor: defaultStrokeColor, dopacity:0.8},
            fill: {title: 'Prenchimento',color:true, opacity: true, dcolor: defaultFillColor, dopacity:0.3},
        },
        id: "city_limit",
        url: layers_url['city_limit'],
        options:{
            show:false
        },
        style:{
            fill:{
                color:defaultFillColor,
                opacity:0.3,
            },
            stroke:{
                color:defaultStrokeColor,
                opacity:0.8,
            },
        }
 * }
 * }
 * 
 */

function LayerControl(options){
    this._map = options.map,
    this._container = options.container;
    this._accordion_id = undefined
    this._layers = options.layers;
    this._elements = {}
    this._options = options.options || {};
    this._current_acoordions = []
    this._pickrs = {}
    this._filter_options = options.filter_options
    this._acoordion_id = ""
    this._cached_jsons = {}
    let context = this
    /**
     * Gera um componente de controle de camadas com as configurações estabelecidas na inicialização do LayerControl
     */
    this.generate = ()=>{
        //criando identificador do accordion. Ramdom no final pra evitar duplicidade
        let acoordion_id = 'layer_control_accordion_' +(Math.random() + 1).toString(36).substring(7);
        
        //tornanco mais facil o acesso a essa informação
        this._accordion_id = acoordion_id 

        //gera a estrutura geral do container
        let accordion_html = _html_handler.generateAccordion(acoordion_id)
        
        //preenche/cria container
        $(this._container).html(accordion_html)

        //gera a caixa de filtragem
        this.generateFilter()
        
        $.each(this._layers, (index, layer)=>{
            //adiciona controle de camada a container
            if(!layer.options.hide){
                this.generateControl(layer)
            }

        })
        //adicionando a lista de acoordions atual
        this._current_acoordions.push(acoordion_id)

        //adiciona eventos necessários para funcionamento
        delegateEvents.call(this, acoordion_id)
    }

    /**
     * Cria um controle de camada para a layer informada.
     * Caso um controle já exista em estado diferente ('carregando', 'erro', etc...), pode-se informar 'only_controls', que no caso procura um card já existente para a layer, e atualiza as opções se possível.
     * @param {Object} layer Objeto de layer informado na inicialização do LayerControl
     * @param {String} acoordion_id  ID do component pai, onde todos os cards serão adicionados
     * @param {Bollean} only_controls Controla se o card já existe, alterando apenas o seu conteudo, sem a necessidade de criar e adicionar outro card.
     */
    this.generateControl = (layer, only_controls=false) =>{
        return new Promise((resolve, reject)=>{
            let card_options = {
                with_controls: true, //adicionar controladores no card
                loaded_layer:true //camada carregada com sucesso?
            }
            if(only_controls){
                this.cardLoadState(layer)
            }
            if(layer.options.show){
                this.handleLayerVisualization(layer.id).then(
                    data=>{
                        console.log('Sucesso ao carregar camada' + layer.title)
                        $(document).trigger('LAYER-CONTROL:LAYER-LOADED', layer)
                        //_html_handler.generateLayerCardStructure(layer, acoordion_id)
                    },
                    error=>{
                        card_options.with_controls = false
                        card_options.loaded_layer = false
                    }
                ).finally(data=>{
                    if(only_controls){
                        //card ja existe, apenas controles
                        $("#collapse_"+layer.id).find('.card-body').html(_html_handler.generateLayerCardBody(layer, card_options))
                        
                    } else {
                        //card não existe, gerar card com controles
                        _html_handler.generateLayerCard(this._accordion_id, layer, card_options)
                    }
                    initializeContainerColorPickers.call(this,layer.id)
                    initializeSelectPicker.call(this,layer)
                    resolve()
                })   
            } else{
                if(!only_controls){
                    $("#"+this._accordion_id).append(_html_handler.generateLayerCardStructure(layer, this._accordion_id))   
                }
                $("#collapse_"+layer.id).find('.card-body').html(_html_handler.generateLayerCardBody(layer, {loaded_layer:false, with_controls:false}))
                resolve()
            }
        })
        
    }
    /**
     * Procura a camada com o id informado, e caso 'show = true', sera requisitada e exibida no mapa com as configurações da layer
     * @param {String} layer_id id da camada
     */
    this.handleLayerVisualization = layer_id =>{
        let layer = this._layers.filter(x=>x.id == layer_id)[0]
        return new Promise((resolve, reject)=>{
            if(layer != undefined && layer.options.show){
                this.getLayer(layer, this._map, resolve, reject)
            } else {
                this.removeLayerFromMap(layers_id)
                resolve()
            }
        })
    }
    /**
     * Faz uma requisição via 'getJSON' no link 'url' informado na layer, e exibe a camada no mapa 
     * Tem um estilo para a feature definido, mas pode ser alterado com o objeto 'style'
     * @param {Object} layer 
     * @param {LeafletMap} map 
     */
    this.getLayer = async (layer,map, resolve, reject)=>{
        let get_layer_style = getLayerStyle
        $(".layer-control-component").trigger("loading.start", {data:'asd'});
        
        //MapComponent não esta sendo usuado diretamente aqui, entao esta sendo instanciado outro apenas pra utilização dos métodos
        let MP = new MapComponent({container:'whatever'})            

        if(layer.limit_type){
        //com o tipo do limite, da pra usar o mapComponent pra carregar a feature de maneira padronizada
            let json
            if(layer.options.cache && this._cached_jsons[layer.limit_type]){
                json = this._cached_jsons[layer.limit_type]
            } else {
                json = await MP.getJSONlimit(layer.limit_type, layer.options.request_options || {simplified:true},getLayerStyle(layer))
                if(layer.options.cache){
                    this._cached_jsons[layer.limit_type] = json
                }
            }
            
            let featureGroup = MP.JSONtoFeature(json, layer.limit_type,getLayerStyle(layer))
            
            //salvando id
            featureGroup.id = layer.id

            //adicioanndo ao mapa
            map.addLayer(featureGroup)

            //adicionando apontamento ao featureGroup para facilitar localização
            layer.featureGroup = featureGroup
            
            //adicionando controle de visibilidade ao featureGroup
            addFeatureControl(featureGroup)

            //evento de click disparado globalmente
            addClickListener(featureGroup)

            //salvando apontamento de cada camada tbm em um array. Para controle de visualização
            //eachFeature no featureGroup, ao remover a layer, perde a instancia, entao n teria como reexibir.
            layer.featureGroup.layers = []
            featureGroup.eachLayer(feature=>{
                layer.featureGroup.layers.push(feature)
            })

            //informando finalização
            $(".layer-control-component").trigger("loading.finish", {data:'asd'});

            if(layer.options && layer.options.zoomToLayer){
                setTimeout(_=>map.fitBounds(featureGroup.getBounds()), 1000)
            }
            resolve()
            
        } else {
            if (layer.layer_type === 'canvas_markers'){
                $.getJSON(layer.url, function(data, status, xhr) {
                    let feature = new L.MarkersCanvas().addTo(map)

                    data = data.features.map(x=>  ({obj_prop: x.properties, latLng: x.geometry.coordinates.reverse()}))

                    let markers = []

                    data.forEach(point=>{
                        if(layer.id === 'outorgas'){
                            if(point.obj_prop){
                                point.obj_prop.is_entry = point.obj_prop['tipo_uso'] === 'Lançamento de Efluentes' ? "true" : "false"
                            } else {
                                point.is_entry = point['tipo_uso'] === 'Lançamento de Efluentes'
                            }                  
                        }
                        const svgCode = generateMarkerSVG(point.obj_prop || point, layer.style);
                        const encodedSvg = btoa(svgCode);
                        const dataURI = `data:image/svg+xml;base64,${encodedSvg}`;

                        var icon = L.icon({
                            iconUrl: dataURI,
                            iconSize: [10, 10],
                            iconAnchor: [5, 5]
                        });

                        let marker = L.marker(point.latLng, {icon: icon, obj_prop: point.obj_prop});
                        markers.push(marker)
                    })

                    feature.addMarkers(markers);

                    feature.type = 'canvas'
                    feature.markers = markers
                    feature.layer = layer
                    feature.id = layer.id

                    layer.featureGroup = feature
                    
                    addClickListener(feature)

                    addFeatureControl(feature)

                    
                    

                    $(feature._canvas).on('click', e =>{
                        e.stopImmediatePropagation()
                        $(document).trigger('LAYER-CONTROL:CANVAS::CLICK', ({event:{latlng:map.containerPointToLatLng({x:e.offsetX, y:e.offsetY})}, featureGroup:feature}))
                    })
                    resolve()   
                }).fail(function() {
                    console.log('forçando timeout')
                    new Promise(r => setTimeout(r, 2000)).then(data=>{
                        Toast.warning({text:"Erro ao carregar a camada" + layer.title })
                        reject(new Error("Whoops!"));
                    });
                    
                })
            } else if (layer.id === 'chuva_agora'){
                let url = layer.layer_type === 'rain' ? `measurements/last_hours_events?hours=${layer.options.hours || 24}&show_all=true` : layer.layer_type === 'level' ?  'measurements/raining_now_flu' : 'measurements/raining_now_flu'
                _http_v1.request(url).then(data=>{
                    let feature = new L.MarkersCanvas().addTo(map)

                    if(layer.layer_type === 'level'){
                        let obj = {}
                        data.json.forEach(measurement=>{
                            if(measurement.parameter_values && (measurement.parameter_values['extravasation'] || measurement.parameter_values['attention'])){
                                obj[measurement.prefix] = obj[measurement.prefix] || {}
                                obj[measurement.prefix].measurements = obj[measurement.prefix].measurements || []
                                obj[measurement.prefix].measurements.push(measurement)
                                obj[measurement.prefix].obj_prop = obj[measurement.prefix].obj_prop || {prefix: measurement.prefix, station_prefix_id: measurement.station_prefix_id, value: measurement.value, parameter_values: measurement.parameter_values, name:measurement.name, station_type_id: 1, station_owner_name: measurement.station_owner_name}
                                obj[measurement.prefix].latLng = obj[measurement.prefix].latLng || [measurement.latitude, measurement.longitude]
                            }
                            
                        }) 
                        data = Object.values(obj)
                    } else {
                        data = data.json.map(x=>  ({obj_prop: x, latLng: [x.latitude, x.longitude]}))
                    }
                    
                    const getColor = value =>{
                        if(value >= 70){
                            return '#f74f78'
                        } else if (value >= 30){
                            return '#ff7b00'
                        } else if(value >= 10){
                            return '#fcb900'
                        } else {
                            return '#16c995'
                        }
                    }

                    const getColorL = (value, parameters) =>{
                        let {attention,alert, emergency, extravasation} = parameters
                        
                        if(extravasation && value >= parseFloat(extravasation)){
                            return '#f74f78'
                        } else if(emergency && value >= parseFloat(emergency)){
                            return '#c0f'
                        } else if(alert && value >= parseFloat(alert)){
                            return '#ffb15c'
                        } else if(attention && value >= parseFloat(attention)){
                            return '#bda501'
                        } else {
                            return '#16c995'
                        }
                    }
                    
                    let markers = []

                    const iconSize = layer.layer_type === 'rain' ? [17, 17] : [11, 11]

                    data.forEach(point=>{
                        if(point.obj_prop.value >= 1){
                            
                            const svgCode = generateRainingNowMarkerSVG({number: layer.layer_type === 'rain' ? parseInt(point.obj_prop.value) : '', fillColor: layer.layer_type === 'rain' ? getColor(parseInt(point.obj_prop.value)) : getColorL(parseInt(point.obj_prop.value), point.obj_prop.parameter_values), strokeColor: 'white', strokeWidth: 10, textColor: 'white', textSize: 60, className:'raining-now-marker'});
                            const encodedSvg = btoa(svgCode);
                            const dataURI = `data:image/svg+xml;base64,${encodedSvg}`;
                            
    
                            var icon = L.icon({
                                iconUrl: dataURI,
                                iconSize: iconSize,
                                iconAnchor: [7, 7]
                            });
    
                            let marker = L.marker(point.latLng, {icon: icon, obj_prop: point.obj_prop});
                            markers.push(marker)
                        }
                        
                    })

                    feature.addMarkers(markers);

                    feature.type = 'canvas'
                    feature.markers = markers
                    feature.layer = layer
                    feature.id = layer.id

                    layer.featureGroup = feature
                    
                    addClickListener(feature)

                    addFeatureControl(feature)

                    $(feature._canvas).on('click', e =>{
                        e.stopImmediatePropagation()
                        $(document).trigger('LAYER-CONTROL:CANVAS::CLICK', ({event:{latlng:map.containerPointToLatLng({x:e.offsetX, y:e.offsetY})}, featureGroup:feature}))
                    })
                    
                    resolve() 
                })
                
            } else {
                $.getJSON(layer.url, function(data, status, xhr) {
                    let featureGroup = L.featureGroup()
                    let smooth = 1
                    if(layer.options && layer.options.smooth){
                        smooth = layer.options.smooth.value
                    }
                    data.features.forEach(feature=>{
                        
                        
                        
                        let l = L.geoJson(feature,getLayerStyle(layer))
                        l.obj_prop = feature.properties

                        let f
                        
                        if(feature.geometry.type === 'MultiLineString'){
                            f = L.polyline(l.getLayers()[0].getLatLngs(), {...getLayerStyle(layer), smoothFactor: smooth})
                        } else {
                            f = L.polygon(l.getLayers()[0].getLatLngs(), {...getLayerStyle(layer),smoothFactor: smooth})
                        }
                        f.properties = feature.properties

                        featureGroup.addLayer(f)
                        
                    })

                    //certificando que o feature tenha o ID passado na inicialização da camada
                    featureGroup.id = layer.id
                    layer.featureGroup = featureGroup
                    addFeatureControl(featureGroup)
                    map.addLayer(featureGroup)
                    $(".layer-control-component").trigger("loading.finish", {data:'asd'});
                    layer.featureGroup.layers = []
                    
                    featureGroup.eachLayer(feature=>{
                        layer.featureGroup.layers.push(feature)
                    })
                    
                    if(layer.options && layer.options.bringToFront){
                        featureGroup.bringToFront()
                    }

                    addClickListener(featureGroup)

                    
                    resolve()
                }).fail(function() {
                    console.log('forçando timeout')
                    new Promise(r => setTimeout(r, 2000)).then(data=>{
                        Toast.warning({text:"Erro ao carregar a camada" + layer.title })
                        reject(new Error("Whoops!"));
                    });
                    
                })
            }
            //caso tipo do limite não informado, será usado url informado no objeto layer
            
        }

        

        
    }
    /**
     * Gera o elemento filtro de acordo com as opções de inicialização do LayerControl
     */
    this.generateFilter = () =>{
        if(this._filter_options){
            $(this._container).find('.filter-container').html(_html_handler.generateFilter(this._filter_options))
        }
    }

    this.filterControls = (text) =>{
        let layers = _filter.filterLayersByTitle(this._layers, text)
        this.hideAllLayerControl()
        layers.map(x=>this.showLayerControl(x.id))
    }

    this.cardLoadState = (layer) =>{
        $("#collapse_"+layer.id).find('.card-body').html(_html_handler.generateBodyLoadState())
    }

    this.removeLayerFromMap = (layer_id) =>{
        let layers = Object.values(this._map._layers).filter(x=>x.id == layer_id)
        layers.map(x=>this._map.removeLayer(x))
    }

    this.showLayerControl = (layer_id) => {
        $('.layer-control-card[data-layer="'+layer_id+'"]').addClass('visible')
    }

    this.hideAllLayerControl = () =>{
        $('.layer-control-card').removeClass('visible')
    }

    this.showAllLayerControl = () =>{
        $('.layer-control-card').addClass('visible')
    }

    this.getLayers  =_ => {
        return this._layers
    }

    this.filterFeaturesFromFeatureGroup = (array_ids, limit_type) =>{
        let layer = this.getLayers().filter(l=>l.limit_type == limit_type)[0]
        if(layer){
            $(layer.select_features_el).selectpicker('val', array_ids)
            return true
        } else {
            return false
        }
        // $('.select-filter-features').selectpicker('val',22)
    }

    this.showLayer = (layer_id, show) =>{
        return new Promise((resolve, reject)=>{
            let layer = this._layers.filter(x=>x.id == layer_id)[0]
            if(layer){
                layer.options.show = show
                this.generateControl(layer,true).then(data=>{
                    resolve(layer)
                })
                if(!show){
                    this.removeLayerFromMap(layer_id)
                    _html_handler.updateLayerHeaderByState(layer_id, 2) 
                }
            } else {
                console.log(layer_id, 'nao existe');
                resolve()
            }
        })
        
        
    }

    function addClickListener(featureGroup){
        featureGroup.on('click', e =>{
            $(document).trigger('LAYER-CONTROL:FEATURE-GROUP::CLICK', ({event:e, featureGroup:featureGroup}))

            //parando evento de click para nao disparar como se fosse um click no mapa
            L.DomEvent.stopPropagation(e);
        })
    }

    function addFeatureControl(featureGroup){
        featureGroup.showLayers = function(layer){
            let context = this //featureGroup
            
            let current_filter = layer.current_filter
            
            if(featureGroup.type != 'canvas'){
                layer.featureGroup.layers.forEach(feature=>{
                    let validations = []
                    feature.showing = false
                    $.each(current_filter, (field, values)=>{
                        validations.push(values.includes(_.get(feature.obj_prop, field).toString()))
                    })
                    if(!validations.includes(false)){
                        feature.showing = true
                        context.addLayer(feature)
                    }
                })
            } else {
                // console.log(layer.featureGroup);
                layer.featureGroup.clear()
                layer.featureGroup.markers.forEach(feature=>{
                    let validations = []
                    feature.showing = false
                    $.each(current_filter, (field, values)=>{
                        
                        let value = _.get(feature.options.obj_prop, field)
                        if(value){
                            validations.push(values.includes(value.toString()))
                        }
                    })
                    if(!validations.includes(false)){
                        feature.showing = true
                        context.addMarker(feature)
                    }
                })
            }
            
        }
        
    }

    function initializeSelectPicker(layer){
        let context = this
        // this.getLayers().forEach(layer=>{

            if(layer.options.show && layer.feature_filter && layer.feature_filter.filterable && layer.featureGroup && layer.feature_filter.filters && layer.feature_filter.filters.length > 0){                
                
                layer.feature_filter.filters.forEach(filter_options=>{
                    let select_container = document.createElement('div')
                    $(select_container).append(`<label>${locale(filter_options.field_name)}</label>`)
                    $(select_container).addClass('control p-3')

                    let container = $('.controls-container-'+layer.id+' .select-filter-features-container')
                    let select_el = _html_handler.generateSelectFilter(layer, filter_options)
                    
                    $(container).append(select_container)
                    $(select_container).append(select_el)
                    $(select_el).selectpicker({liveSearch:true, actionsBox:true,deselectAllText:"Nenhum", selectAllText:"Todos"})
                    
                    layer.select_features_el = select_el
                    
                    $(select_el).on('changed.bs.select', function(e){
                        console.log(filter_options);
                        
                        let selected_array = $(e.target).selectpicker('val')

                        layer.current_filter = layer.current_filter || {}
                        layer.current_filter = {...layer.current_filter, ...{[filter_options.field_value]:  selected_array}}
                        console.log(layer.current_filter);
                        
                        if(layer.featureGroup.type != 'canvas'){
                            layer.featureGroup.clearLayers()
                            layer.featureGroup.showLayers(layer)
                        } else {
                            // layer.featureGroup.clear()
                            layer.featureGroup.showLayers(layer)
                        }
                        
                        
                    })
                })
                
            }
        // })        
        
    }

    function locale(text){
        let obj = {
            'station_type_name': 'Tipo de Posto',
            'prefix': 'Prefixo',
            'operation_status': 'Status Operação',
            'station_owner_name': 'Proprietário',
            'nm_mun': 'Município',
            'is_telemetric': 'Telemétrico'
        }

        return obj[text] || text
    }
    

    // MÉTODOS PRIVADOS

    function addConditionalClass(layer){
        let conditions = layer.style.conditional
        
        layer.featureGroup.getLayers().forEach(feature=>{
              
            feature.on('add', function() {
                if (feature._customClass) {
                    feature._icon.className += " " + feature._customClass;
                }
            });

            conditions.forEach(condition=>{
                let boolean = false
                condition.conditions.forEach(rules=>{
                    boolean = _.get(feature.obj_prop, rules[0]).toString() === rules[1].toString()
                })
                
                if(boolean){
                    L.DomUtil.addClass(feature._icon, condition.className);
                    feature._customClass = condition.className
                }
                
            })
        })

        
        
    }

    /**
     * Gera o estilo da camada de acordo com os parametros informados no objeto Layer. Caso não informado, retorna um estilo pré definido
     * @param {Object} layer 
     * @returns {Object} estilo da camada
     */
    function getLayerStyle(layer){
        //default layer
        let options = {color: "#37384e",fillColor: "#37384e", fillOpacity:0.1, weight: 1.5}
        if(layer.style != undefined){
            if(layer.style.fill != undefined){
                options.fillColor = layer.style.fill.color || '#37384e'
                options.fillOpacity = layer.style.fill.opacity
            }
            if(layer.style.stroke != undefined){
                options.color = layer.style.stroke.color || '#37384e'
                options.opacity = layer.style.stroke.opacity
            }
        }
        return options
        
    }

    /**
     * Delegando todos os eventos do accordion/filtro
     * @param {String} container_id 
     */
    function delegateEvents(container_id){
        let context = this
        $(document).on('click','.reload-layer', (event)=>{
            let layer_id = event.target.dataset.id
            this.showLayer(layer_id)
        })
        $(document).on('change','.range-picker-layer-options', (e)=>{
            let layer_id = e.target.dataset.id
            let type = e.target.dataset.type
            setLayerStyle.call(this, layer_id, {[type]: parseInt(e.target.value)/100})
        })
        $(document).on('keyup change','input.layer-control', (e)=>{
            let layer_id = e.target.dataset.id
            let type = e.target.dataset.type
            if(e.target.value != ""){
                let value = inputRulesValidate(e.target.value, type)
                e.target.value = value
                setLayerStyle.call(this,layer_id, {[type]: value})    
            }
        })
        $(document).on('click','.layer-control-component .button-toggle-layer', (e)=>{
            let method = e.target.dataset.method
            let layer_id = e.target.dataset.id
            let action = (method == 'add') ? true : false
            $.each(this._layers.filter(x=>x.id == layer_id), (index,layer)=>{
                context.showLayer(layer_id, action)
                $(document).trigger('LAYER-CONTROL:LAYER-TOGGLE', {layer:layer, action:action})
            })
        })
        $(document).on('keyup change', '.filter-box-input', (e)=>{
            this.filterControls(e.target.value)
        })
        //evento de click no botão de limpeza da caixa de filtro
        $(document).on('click', '.filter-box .clear', e=>{
            //limpando a textbox de filtro
            $('.filter-box-input').val('')
            //trigger do change para executar o filtro com o campo vazio
            $('.filter-box-input').trigger('change')
        })
        //evento de click no botão de todos/adicionadas da caixa de filtro
        $(document).on('click', '.only_added_span', (e)=>{
            _filter.toggleOnlyAdd()
            _filter.changeButtonStyle(e.target)
        })

        context._map.on('zoomend', e=>{
            setLayersSmooth(context._map.getZoom())
        })
    }

    function generateMarkerSVG(point, style_config){
        let html = '<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">'
        let style = 'fill:lime;stroke:purple;stroke-width:3' //config pré definida (espero nunca usar)
        
        if(style_config){
            if(style_config.conditional && style_config.conditional.length > 0){
                style_config.conditional.forEach(condition=>{
                    let resp = condition.rules.map(rule=> _.get(point, rule[0]).toString() == rule[1])
                    if(!resp.includes(false)){
                        style = condition.style
                    }
                })
               
            } else if(style_config.fill || style_config.stroke){
                style = `fill:${style_config.fill.color};stroke:${style_config.stroke.color};stroke-width:${style_config.stroke.width || 3}`
            }
        }
        
        if(point.station_type_id){
            html += point.station_type_id === 1 ? `<polygon points="0,100, 50,0 100,100" style="${style}" />` : `<circle cx="50" cy="50" r="50" style="${style}"/>`
        } else if(style_config.icon_type === 'losango'){
            html += `<path d="M 50,0 L 100,50 L 50,100 L 0,50 Z" style="${style}"/>`
        } else {
            html += `<path d="M 50,0 L 100,50 L 50,100 L 0,50 Z" style="${style}"/>`
        }
        return html + '</svg>'
    }

    function generateRainingNowMarkerSVG(options){
        return `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">`+
        // `<svg width="${options.sizeWidth}" height="${options.sizeHeight}" xmlns="http://www.w3.org/2000/svg" id="svgCircle">`+
            `<circle cx="50" cy="50" r="50" fill="${options.fillColor}" stroke="${options.strokeColor}" stroke-width="${options.strokeWidth}"/>` + 
            `<text font-family="Arial, Helvetica, sans-serif" x="50" y="60" fill="${options.textColor}" font-size="${options.textSize}" text-anchor="middle" alignment-baseline="middle"> ${options.number}</text>`+
        `</svg>`;
    }

    function setLayersSmooth(zoom){
        
        context._layers.filter(l=>l.options && l.options.show && l.featureGroup && l.options.dynamic_smooth).forEach(layer=>{
            // console.log(layer, 'lay');
            layer.featureGroup.layers.forEach(l=>{
                let smooth = layer.options.dynamic_smooth[0][1]
                layer.options.dynamic_smooth.forEach(values=>{
                    if(zoom > values[0]){
                        smooth = values[1]
                    }
                }) 
                l.options.smoothFactor = smooth
                
            })
            
            //faster then redraw looks like
            layer.featureGroup.clearLayers()
            layer.featureGroup.layers.map(x=>layer.featureGroup.addLayer(x))
        })
    }

    /**
     * Inicializando Color Pickr no card correspondente a layer
     * Sempre que um card é criado com as options, é necessário chamar esse método para o funcionamento do color picker
     * @param {String} layer_id 
     */
    function initializeContainerColorPickers(layer_id){
        //Se apenas trocar o HTML da div, o picker ainda fica instancionado no navegador e os elementos ainda construidos no HTML.
        //Para resolver isso, a instancia do pickr esta sendo salva por camada (em this._pickrs) para que ao inicializar novos pickrs, o método destroyAndRemove dos pickrs antigos seja chamado.
        //destroyAndRemove Limpa completamente o pickr da memória do navegador e deleta seus elementos
        let removeCurrentPickrs = layer_id => {
            $.each(this._pickrs[layer_id], (index, pickr)=>{
                pickr.destroyAndRemove()
            })
            this._pickrs[layer_id] = []
        }
        removeCurrentPickrs(layer_id)
        $("#collapse_"+layer_id).find('.color-picker').each((index,elem)=>{
            let elem_id = elem.dataset.id
            let type = elem.dataset.type
            let dcolor = elem.dataset.color
            let layers = Object.values(this._map._layers).filter(x=>x.id == elem_id)
            const pickr = Pickr.create({
                el: elem,
                theme: 'nano', // or 'monolith', or 'nano'
                default: dcolor, 
                components: {
                    // Main components
                    preview: true,
                    opacity: false,
                    hue: true,
                    // Input / output Options
                    interaction: {
                        hex: true,
                        rgba: true,
                        input: true,
                        clear: true,
                        save: true
                    }
                }
            });
            pickr.on('change', (color, source, instance) => {
                //atualizando a cor do elemento da camada
                layers.map(x=>x.setStyle({[type]:color.toHEXA().toString()}))
                //atualizando a cor do botão
                instance._root.button.style.setProperty('--pcr-color', color.toRGBA().toString());
            })
            pickr.on('save', function(color, instance){
                //funções do evento save não são overrited por esse listener
                instance.hide()
            })
            pickr.on('clear', (color, instance)=>{
                //removendo a cor do elemento da camada
                //funções do evento clear não são overrited por esse listener
                layers.map(x=>x.setStyle({[type]:'none'}))
            })
            this._pickrs[layer_id].push(pickr)
        })
    }
    /**
     * Coloca o estilo informado na camada informada
     * O ID da camada é procurado na lista de camadas do mapa instanciado. Caso encontre, o estilo será aplicado.
     * @param {String} layer_id 
     * @param {Object} style 
     */
    function setLayerStyle(layer_id, style){
        let layers = Object.values(this._map._layers).filter(x=>x.id == layer_id)
        //atualizando a cor do elemento da camada
        layers.map(x=>x.setStyle(style))
    }

    function inputRulesValidate(value, type){
        switch(type){
            case 'weight': 
                return parseInt(value) >= 0 && parseInt(value) <= 10 ? value : 1
            default:
                return value
        }
    }
}
window.LayerControl = LayerControl